import axios from "axios";
const endpoint = process.env.VUE_APP_BASE_API + "/api/master/zones";

export default {
  async getAll(filter) {
    return await axios
      .get(endpoint + `/list${filter}`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getAllActive() {
    return await axios
      .get(endpoint + "/list/active")
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getAllGroups() {
    return await axios
      .get(endpoint + "/list/group")
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getZonesByGroupId(params) {
    return await axios
      .get(endpoint + `/by-group?${params}`)
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getLocation(group, id) {
    let url = `${endpoint}/location`;
    let queries = [];

    if (id) {
      queries.push(`id=${id}`);
    }

    if (group) {
      queries.push(`group=${group}`);
    }

    if (queries.length > 0) {
      url += `?${queries.join("&")}`;
    }

    return await axios
      .get(url)
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async create(request) {
    return await axios
      .post(endpoint, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async update(request) {
    return await axios
      .put(endpoint, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async delete(id) {
    return await axios
      .delete(endpoint + `/${id}`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  }
};



// WEBPACK FOOTER //
// ./src/services/master/zone/zoneService.js